module.exports = __webpack_public_path__ + "img/bg7-3.d62e780b.png";